import { SelectFieldProps } from './SelectField';
import { Theme, css } from '@emotion/react';

export const selectFieldRoot =
  (disabled: SelectFieldProps['disabled']) =>
  ({ spacing, typography, colors }: Theme) => css`
    display: inline-grid;
    & .MuiInputBase-input {
      box-sizing: border-box;
      height: auto;
      padding: ${spacing(1.5)}px ${spacing(5)}px ${spacing(1.5)}px ${spacing(1.5)}px;
      ${typography.variant('body')};
      line-height: 20px;
    }

    & svg {
      top: ${spacing(1.5)}px;
      right: ${spacing(1.5)}px;
    }

    ${disabled &&
    `
	    background: ${colors.bgLighter}
    `}
  `;

export const selectFormControl =
  (
    fullWidth: SelectFieldProps['fullWidth'],
    qualifier: SelectFieldProps['qualifier'],
    disabled: SelectFieldProps['disabled']
  ) =>
  ({ colors, spacing }: Theme) => css`
    width: ${fullWidth ? '100%' : 'auto'};
    position: initial;
    gap: ${spacing(0.5)}px;

    & .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${colors.borderDefault};
      top: 0;
    }

    & .MuiOutlinedInput-notchedOutline legend {
      display: none;
    }

    & .MuiFormLabel-asterisk {
      margin-left: ${spacing(0.25)}px;
      color: ${colors.fgDangerBase};
      ${disabled && `display: none`}
    }
    ${qualifier === 'optional' &&
    `
	  & .MuiInputLabel-root::after {
      ${disabled && `display: none`};
      margin-left: ${spacing(0.25)}px;
		  color: ${colors.fgSubtle};
		  content: '(optional)';
		  visibility: visible;
		}
	  `}
  `;

export const selectFieldLabel =
  (disabled: SelectFieldProps['disabled']) =>
  ({ typography, colors }: Theme) => css`
    position: initial;
    ${typography.variant('captionStrong')};
    color: ${disabled ? colors.fgDisabled : colors.fgDefault};

    &.MuiInputLabel-outlined {
      transform: none;
    }
  `;

function getColorFromState(
  { fgDangerBase, fgDisabled, fgSubtle }: Theme['colors'],
  error?: boolean,
  disabled?: boolean
) {
  if (disabled) {
    return fgDisabled;
  }
  if (error) {
    return fgDangerBase;
  }
  return fgSubtle;
}

export const selectFieldHelperText = (
  { typography, colors }: Theme,
  disabled: SelectFieldProps['disabled'],
  error: SelectFieldProps['error']
) => css`
  color: ${getColorFromState(colors, error, disabled)};
`;
